module.exports = __webpack_public_path__ + "de77a722/img/settings-ico.a214628d.svg";